import { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Switch } from "antd";
import { t } from "i18next";
import ApiService from "../../core/service/ApiService";

export default function AppointmentTypeModal({ type, onSuccess }) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        form.setFieldsValue(type
            ? {
                name: type.name,
                enabizEnabled: type.enabizEnabled,
                overrideInstitutionPrice: type.overrideInstitutionPrice,
                hidePatientBalance: type.hidePatientBalance ?? 0,
            }
            : { enabizEnabled: false, overrideInstitutionPrice: false, hidePatientBalance: 0 });
    }, []);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const data = { ...values, hidePatientBalance: values.hidePatientBalance ?? 0 };
            const res = type
                ? await ApiService.AppointmentType.EditAppointmentType(type.id, data)
                : await ApiService.AppointmentType.CreateAppointmentType(data);
            if (res.success) onSuccess && onSuccess();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item name="name" label={t('Name')} rules={[{ required: true, whitespace: true, message: t('Please enter name') }]}>
                <Input maxLength={512} />
            </Form.Item>
            <Form.Item
                name="enabizEnabled"
                label={t('E-Nabız Sending Status')}
                valuePropName="checked"
                extra={t('Automatic E-Nabız sending requires the unit and the institution to be enabled as well.')}
            >
                <Switch />
            </Form.Item>
            <Form.Item
                name="overrideInstitutionPrice"
                label={t('Override Institution Price')}
                valuePropName="checked"
                extra={t('When on, operation prices come from this appointment type\'s price list instead of the institution price.')}
            >
                <Switch />
            </Form.Item>
            <Form.Item
                name="hidePatientBalance"
                label={t('Hide Patient Balance Threshold')}
                extra={t('In the patient portal, the balance is hidden above this amount. 0 = off.')}
            >
                <InputNumber min={0} precision={2} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                <Button type="primary" htmlType="submit" loading={loading}>{t('Save')}</Button>
            </Form.Item>
        </Form>
    );
}
